import _ from "lodash";
const stringCompareTo = (a, b) => {
  return a.localeCompare(b, void 0, { sensitivity: "accent" });
};
const numberCompareTo = (a, b) => {
  return a - b;
};
const booleanCompareTo = (a, b) => {
  if (a === b) {
    return 0;
  }
  if (!!a) {
    return 1;
  }
  return -1;
};
const versionCompareTo = (a, b) => {
  const aParts = a.split(".");
  const bParts = b.split(".");
  if (!validateParts(aParts) || !validateParts(bParts)) {
    return NaN;
  }
  for (let i = 0; i < aParts.length; ++i) {
    if (bParts.length === i) {
      return 1;
    }
    if (aParts[i] === bParts[i]) {
      continue;
    }
    if (aParts[i] > bParts[i]) {
      return 1;
    }
    return -1;
  }
  if (aParts.length !== bParts.length) {
    return -1;
  }
  return 0;
};
const validateParts = (parts) => {
  return _.every(parts, (part) => isPositiveInteger(part));
};
const isPositiveInteger = (x) => {
  return /^\d+$/.test(x);
};
const isVersion = (version) => {
  const versionRegex = /^\d+\.\d+\.\d+(\.\d+)?$/;
  return versionRegex.test(version);
};
export {
  booleanCompareTo,
  isVersion,
  numberCompareTo,
  stringCompareTo,
  versionCompareTo
};
//# sourceMappingURL=common.utils.js.map
